import { createAction } from '@reduxjs/toolkit';

const OPEN_REPORT_CONTENT_MODAL = 'REPORT_CONTENT::OPEN_FORM';
const openReportContentModal = createAction(
    OPEN_REPORT_CONTENT_MODAL,
    (conversationSid: string) => {
        return {
            payload: { conversationSid },
        };
    }
);

const DISMISS_REPORT_CONTENT_MODAL = 'REPORT_CONTENT::DISMISS_FORM';
const dismissReportContentModal = createAction(DISMISS_REPORT_CONTENT_MODAL);

const SET_REPORT_TYPE = 'REPORT_CONTENT::SET_REPORT_TYPE';
const setReportType = createAction(SET_REPORT_TYPE, (reportType: string) => {
    return {
        payload: { reportType },
    };
});

const SET_SUBMISSION_FAILURE = 'REPORT_CONTENT::SET_SUBMISSION_FAILURE';
const setSubmissionFailure = createAction(SET_SUBMISSION_FAILURE, (errorResponse?: object) => {
    return {
        payload: { errorResponse },
    };
});

const SET_SUBMISSION_SUCCESS = 'REPORT_CONTENT::SET_SUBMISSION_SUCCESS';
const setSubmissionSuccess = createAction(SET_SUBMISSION_SUCCESS);

const CLEAR_SUBMISSION_STATUS = 'REPORT_CONTENT::CLEAR_SUBMISSION_STATUS';
const clearSubmissionStatus = createAction(CLEAR_SUBMISSION_STATUS);

const SUBMIT_MODERATION_REQUEST = 'REPORT_CONTENT::SUBMIT_FORM';
const submitModerationRequest = createAction(SUBMIT_MODERATION_REQUEST);

const UPDATE_REPORT_DETAILS = 'REPORT_CONTENT::UPDATE_REPORT_DETAILS';
const updateReportDetails = createAction(UPDATE_REPORT_DETAILS, (reportDetails: string) => {
    return {
        payload: { reportDetails },
    };
});

export {
    OPEN_REPORT_CONTENT_MODAL,
    DISMISS_REPORT_CONTENT_MODAL,
    SET_REPORT_TYPE,
    UPDATE_REPORT_DETAILS,
    SET_SUBMISSION_FAILURE,
    SET_SUBMISSION_SUCCESS,
    CLEAR_SUBMISSION_STATUS,
    SUBMIT_MODERATION_REQUEST,
    openReportContentModal,
    dismissReportContentModal,
    setReportType,
    updateReportDetails,
    setSubmissionFailure,
    setSubmissionSuccess,
    clearSubmissionStatus,
    submitModerationRequest,
};
